import { EventBus } from '../../helpers';

export type EmailPlanChangedPayload = {
  planId: number;
  planName: string;
  previousPlanId: number | null;
};

type EmailPlansEvents = {
  emailPlanChanged: [payload: EmailPlanChangedPayload];
  vision6PlanClicked: [];
  smsBundleRemoved: [];
};

class EmailPlansEventBus extends EventBus<EmailPlansEvents> {}

export const emailPlansEventBus = new EmailPlansEventBus();
